import { Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { RecentBattleEntry, RecentBattlesPayload } from '../types/server';

// Feeds the home "Recent Battles" bar from belch's GET /battles/recent (count is
// server-defined; no client limit). The lean BATTLE_COMPLETE broadcast is only a
// "re-pull" signal — see RecentBattlesComponent.
@Injectable({ providedIn: 'root' })
export class RecentBattlesService {
  private readonly _battles = signal<RecentBattleEntry[]>([]);
  readonly battles = this._battles.asReadonly();

  private readonly base = environment.faucetEndpoint.replace(/\/faucet$/, '');
  private inflight = false;

  async refresh(): Promise<void> {
    if (this.inflight) return;
    this.inflight = true;
    try {
      const res = await fetch(
        `${this.base}/battles/recent?network=${environment.network}`
      );
      if (!res.ok) return;
      const payload = (await res.json()) as RecentBattlesPayload;
      this._battles.set(payload.battles ?? []);
    } catch {
      // Keep the last good list on transient failure.
    } finally {
      this.inflight = false;
    }
  }
}
